import { PATHS } from './paths';

export const ERROR_CONTENT_TYPES = {
  NOT_FOUND_DEFAULT: 'default',
};

export const ERROR_CONTENT = {
  [ERROR_CONTENT_TYPES.NOT_FOUND_DEFAULT]: {
    heading: 'Keep calm and try again',
    body: `The page you’re looking for could have been deleted or never
              existed.`,
    button: {
      location: PATHS.home,
      text: 'Home',
    },
    statusCode: 404,
  },
};
